import React from 'react';
import UtilityService from '../../../services/UtilityService';

export type ShippingMethodDisplayProps = {
  name: string;
  price: string;
};

const ShippingMethodDisplay: React.FC<ShippingMethodDisplayProps> = ({
  name,
  price,
}: ShippingMethodDisplayProps) => {
  return (
    <div className="flex flex-col content-start text-sm">
      <div>{UtilityService.html5Decode(name)}</div>
      <div>{price}</div>
    </div>
  );
};

export default ShippingMethodDisplay;
